import { FastApiAxiosInstance } from 'common/service/axiosInstances';

const modelLibrary = {
  // 获取单个资产信息
  getArtDetails(payload: any): ExtendAxioResponse {
    return FastApiAxiosInstance.get('api/v1/asset/detail', { params: payload });
  },
  // 按照名称进行搜索
  searchArt(params: { assetName?: string; assetType?: string; pageSize: number; cursorIndex?: number }) {
    return FastApiAxiosInstance.get<{
      pageSize: number;
      pageIndex: number;
      total: number;
      lastIndex: number;
      items: any[];
    }>('api/v1/asset/list', {
      params,
    });
  },
  // 下载此资产
  downloadArt(payload: any): ExtendAxioResponse {
    return FastApiAxiosInstance.get('api/v1/asset/download', { params: payload });
  },
};

export default modelLibrary;
